import i18next from 'i18next';
import { detectLocale } from '../cookies/detectLocale';
export var getFixedT = function (lng, ns, keyPrefix) {
    if (lng === void 0) { lng = detectLocale(); }
    return i18next.getFixedT(lng, ns, keyPrefix);
};
